export interface ServiceType {
  TYPE_ID: number;
  TYPE_CODE: string;
  TYPE_DESC: string;
}

export const Pump: ServiceType = {
  TYPE_ID: 1,
  TYPE_CODE: '0001',
  TYPE_DESC: 'Pumping Service',
};
